import { Main, Home, HomeMktAdmin } from './components'
export const ViewPerfil = r => require.ensure([], () => r(require('../../Perfil/components/ViewPerfil')), 'Auth-bundle')


const children = [
  {
    name: 'home.index',
    path: 'painel',
    component: Home,
    meta: {
      requiresAuth: true,
      title: 'Visão Geral',
      permission: 'public',
      breadcrumbs: [
        {
          name: 'Visão Geral',
          pathName: 'home.index'
        },
      ]
    }
  },
  {
    name: 'home2.index',
    path: 'meus-indicadores',
    component: HomeMktAdmin,
    meta: {
      requiresAuth: true,
      title: 'Meus Indicadores',
      permission: 'public',
      breadcrumbs: [
        {
          name: 'Meus Indicadores',
          pathName: 'home2.index'
        },
      ]
    }
  },
  {
    name: 'home.perfil.view',
    path: 'meus-dados',
    component: ViewPerfil,
    meta: {
      requiresAuth: true,
      title: 'Visão Geral',
      permission: 'public',
      breadcrumbs: [
        {
          name: 'Meus Dados',
          pathName: ''
        },
      ]
    }
  },
]

export default [{
  name: 'home',
  children,
  path: '/app',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
